/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_AlertsInputs */

const en_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerts`)
};

const ar_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنبيهات`)
};

const bn_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যালার্ট`)
};

const de_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnungen`)
};

const es_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas`)
};

const fr_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes`)
};

const pt_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas`)
};

const zh_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`警报`)
};

const tr_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uyarılar`)
};

const ru_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оповещения`)
};

const pl_svchip_alerts = /** @type {(inputs: Svchip_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerty`)
};

/**
* | output |
* | --- |
* | "Alerts" |
*
* @param {Svchip_AlertsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_alerts = /** @type {((inputs?: Svchip_AlertsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_AlertsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_alerts(inputs)
	if (locale === "bn") return bn_svchip_alerts(inputs)
	if (locale === "de") return de_svchip_alerts(inputs)
	if (locale === "es") return es_svchip_alerts(inputs)
	if (locale === "fr") return fr_svchip_alerts(inputs)
	if (locale === "pt") return pt_svchip_alerts(inputs)
	if (locale === "zh") return zh_svchip_alerts(inputs)
	if (locale === "tr") return tr_svchip_alerts(inputs)
	if (locale === "ru") return ru_svchip_alerts(inputs)
	if (locale === "pl") return pl_svchip_alerts(inputs)
	return en_svchip_alerts(inputs)
});